<template>
    <!-- 指标 -->
    <Dropdown class="cm-indicator" trigger="click" :transfer="true">
        <button class="header-button-ghost">
            <!-- <span class="header-button-ghost-span left">{{isDefaultIndicator?'默认':'自定义'}}</span> -->
            <span class="header-button-ghost-span left">自定义列</span>
            <i class="icon header-button-ghost-down"></i>
        </button>
        <DropdownMenu slot="list" class="default-manage-list-wrap">
            <div class="indicator-box" :style="{width: w}">
                <div class="indicator-list">
                    <div class="indicator-row" v-for="(row,key) in indicatorList" :key="key" v-if="row.length > 0">
                        <div class="indicator-item" @click.stop="selectIndicatorRow(key)">
                            <i class="icon icon-checkbox" :class="{'active':indicatorRowSelect[key]}"></i>
                            <span>{{indicatorRowName[key]}}</span>
                        </div>
                        <div class="indicator-item" v-for="(item, index) in row" :key="index" @click.stop="item.selected=!item.selected">
                            <i class="icon icon-checkbox" :class="{'active':item.selected}"></i>
                            <span>{{item.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="indicator-footer">
                    <div class="indicator-footer-left">
                        <span @click.stop="clearIndicator" class="btn-blue" style="margin-right:0.2rem;">重置</span>
                        <span @click.stop="resetIndicator" class="btn-blue">默认</span>
                    </div>
                    <div class="indicator-footer-right">
                        <Button @click.stop="onSaveIndicator('cancel')" type="ghost" style="margin-right:0.2rem;">取消</Button>
                        <Button @click.stop="onSaveIndicator('save')" type="primary">保存</Button>
                    </div>
                </div>
            </div>
        </DropdownMenu>
    </Dropdown>

</template>

<script>
import mixins from '@/mixins/index.js';
import tablelist from '@/server/tablelist.js';
export default {
    name: 'managementSeries',
    mixins: [mixins],
    watch: {},
    props: {
        type: {
            default: 'series',
            type: String,
        },
        w: {
            default: '6rem',
            type: String,
        },
    },
    data() {
        return {
            //指标组名
            indicatorList: tablelist[this.type],
            indicatorRowName: {
                0: '配置项',
                1: '广告端',
                2: '转化',
                3: '成本',
            },
        };
    },
    mounted() {
        if (window.localStorage && window.localStorage[this.type]) this.indicatorList = JSON.parse(window.localStorage[this.type]);
        this.$emit('onIndicatorList', this.indicatorList);
    },
    computed: {
        // 全部指标的数组
        indicatorArr() {
            const arr = [];
            for (let i in this.indicatorList) {
                arr.push(...this.indicatorList[i]);
            }
            return arr;
        },
        // 指标每一组的全选
        indicatorRowSelect() {
            return {
                0: this.indicatorList[0].every(item => item.selected),
                1: this.indicatorList[1].every(item => item.selected),
                2: this.indicatorList[2].every(item => item.selected),
                3: this.indicatorList[3].every(item => item.selected),
            };
        },
        // 指标栏是否默认
        isDefaultIndicator() {
            return !this.indicatorArr.some(item => item.selected != item.isDefault) || this.indicatorArr.every(item => !item.selected);
        },
        // 指标字符串
        indicatorString() {
            let str = '';
            if (!this.isDefaultIndicator) {
                str = this.indicatorArr
                    .filter(item => item.selected)
                    .map(item => item.code)
                    .join(',');
            }
            return str;
        },
    },
    methods: {
        /*
		 * @description 重置指标
		 */
        clearIndicator() {
            for (let i in this.indicatorList) {
                this.indicatorList[i].forEach(item => (item.selected = false));
            }
        },
        /*
		 * @description 点击指标取消，确定按钮
		 */
        onSaveIndicator(type) {
            this.$root.$el.click();
            if (this.isDefaultIndicator) {
                for (let i in this.indicatorList) {
                    this.indicatorList[i].forEach(item => (item.selected = item.isDefault));
                }
            }
            if (type === 'save') {
                this.$emit('onIndicatorList', this.indicatorList);
                if (window.localStorage) window.localStorage[this.type] = JSON.stringify(this.indicatorList);
            } else {
                for (let i in this.indicatorList) {
                    this.indicatorList[i].forEach(item => (item.selected = item.isDefault));
                }
                this.indicatorList = this.deepClone(this.indicatorList);
            }
        },
        /**
         * @description 默认指标
         */
        resetIndicator() {
            for (let i in this.indicatorList) {
                this.indicatorList[i].forEach(item => (item.selected = item.isDefault));
            }
        },
        /**
         * @description 指标分组全选
         * @param value:string 选择的组
         */
        selectIndicatorRow(value) {
            const bool = !this.indicatorRowSelect[value];
            this.indicatorList[value].forEach(item => (item.selected = bool));
        },
    },
};
</script>

<style lang="scss">
//指标box
.ivu-select-dropdown.ivu-dropdown-transfer {
    max-height: 7rem;
}
.indicator-box {
    width: 6rem;
    max-height: 7rem;
    .indicator-list {
        display: flex;
        .indicator-row {
            display: flex;
            flex: 0 0 1.5rem;
            flex-direction: column;
            .indicator-item {
                display: flex;
                align-items: center;
                padding: 0 0.2rem;
                line-height: 0.3rem;
                font-size: 0.14rem;
                .icon-checkbox {
                    margin-right: 0.1rem;
                    width: 0.16rem;
                    height: 0.16rem;
                    background-position: -0.07rem -1.66rem;
                }
            }
            .indicator-item:nth-of-type(1) {
                font-size: 0.16rem;
                line-height: 0.5rem;
                margin-bottom: 0.1rem;
                border-bottom: 1px solid #dfe2e5;
            }
        }
    }
    .indicator-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.2rem 0.5rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/quota.vue